import { CatalogoAgrupamento, LinkAgrupamentoInfo, VerificacaoHash } from "../types/LinkAgrupamento";
import { api } from "./useApi";

export const LinkAgrupamentoApi = () => ({
  buscar: async (): Promise<LinkAgrupamentoInfo> => {
    const response = await api.post("/link_agrupamento/buscar");
    return response.data;
  },

  catalogos: async (): Promise<CatalogoAgrupamento[]> => {
    const response = await api.post("/link_agrupamento/catalogos");
    return response.data;
  },

  verificarHash: async (hash: string): Promise<VerificacaoHash> => {
    const response = await api.post("/link_agrupamento/verificar_hash", { hash });
    return response.data;
  },

  gerarHash: async (): Promise<string> => {
    const response = await api.post("/link_agrupamento/gerar_hash");
    return response.data.hash;
  },

  salvar: async (hash: string, catalogos: number[]): Promise<LinkAgrupamentoInfo> => {
    const response = await api.post("/link_agrupamento/salvar", { hash, catalogos });
    return response.data;
  },

  excluir: async (): Promise<LinkAgrupamentoInfo> => {
    const response = await api.post("/link_agrupamento/excluir");
    return response.data;
  },
});
